import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';
import InputGroup2 from '../components/InputGroup2';

const BooksCount = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>정기간행물</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup2
              title={'교회지남'} //
              value={reportMxData?.books_compas}
              setReportMxData={setReportMxData}
              reportColumnName={'books_compas'}
              disabled={isReadOnly}
              unit={'부'}
            />
          </div>
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup2
              title={'장년교과'} //
              value={reportMxData?.books_senior}
              setReportMxData={setReportMxData}
              reportColumnName={'books_senior'}
              disabled={isReadOnly}
              unit={'부'}
            />
          </div>
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup2
              title={'청소년교과'} //
              value={reportMxData?.books_teen}
              setReportMxData={setReportMxData}
              reportColumnName={'books_teen'}
              disabled={isReadOnly}
              unit={'부'}
            />
          </div>
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup2
              title={'유년교과'} //
              value={reportMxData?.books_junior}
              setReportMxData={setReportMxData}
              reportColumnName={'books_junior'}
              disabled={isReadOnly}
              unit={'부'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BooksCount;
